// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"e0b71672","538":"e0b71672"}[chunkId] + ".chunk.css";
};